import { RefreshCw } from "lucide-react";

import { Button } from "components/ui/button";
import Card from "./Card";

interface CaseActionsProps {
  canReopen: boolean;
  onReopen: () => void;
}

const CaseActions: React.FC<CaseActionsProps> = ({ canReopen, onReopen }) => {
  if (!canReopen) {
    return null;
  }

  return (
    <Card title="Actions">
      <div className="flex flex-col gap-3 p-6">
        <Button variant="outline" onClick={onReopen}>
          <RefreshCw />
          Re-request application
        </Button>
      </div>
    </Card>
  );
};

export default CaseActions;
